/** How long a couple's note may be. Same ceiling as a vendor review. */
export const COUPLE_FEEDBACK_BODY_MAX = 4000

/** How long the venue's own note on an answer may be. */
export const COUPLE_FEEDBACK_NOTE_MAX = 2000

/**
 * How many public review places a venue can offer. Enough for every site a
 * venue might use, few enough that the couple's page stays a short list.
 */
export const REVIEW_LINKS_MAX = 10

/** How long a review place's name may be: it reads "Review on <name>". */
export const REVIEW_LINK_NAME_MAX = 40
